import React, { JSXElementConstructor, ReactElement } from "react";
import { AdsFactoryStrategyStatementButton, AdsStatement } from "../../interfaces";
import { StrategyStatementButtonCancelWaiting, StrategyStatementButtonChangePlan } from "../screens/components";

export class AdsFactoryStrategyStatementButtonImpl implements AdsFactoryStrategyStatementButton {
    createButton(ads: AdsStatement, isUpdateable: boolean): ReactElement<any, string | JSXElementConstructor<any>> {
        if (ads.status === 'WAITING') return <StrategyStatementButtonCancelWaiting id={ads.id} biStatus={ads?.bi_status} />
        if (!isUpdateable) return <></>
        if (ads.status === 'ACTIVATED') return <StrategyStatementButtonChangePlan subscription={ads} />
        return <></>;
    }
}